module.exports = __webpack_public_path__ + "static/christina-yacht-5-2e21e59406a31143bb1a1f991c03c7fc.jpg";